<template>
  <div class="my-demo-wrap">
    <div class="my-demo-title">
      <h2>{{mTitle}}</h2>
      <p>{{subTitle}}</p>
    </div>
    <div class="item-list-wrap">
      <div class="demo-flex" v-for="(item, index) in demoList">
        <div class="demo-flex-item">
          <a href="javascript:;">{{item.username}}-{{index}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "list",
    data() {
      return {
        mTitle: 'Demo列表测试',
        subTitle: "Demo列表测试后续待优化页面跳转效果",
        demoList: []
      }
    },
    mounted() {
      this.getDemoList();
    },
    methods: {
      getDemoList() {
        //查询测试列表数据，来自MOCK
        this.$http.getDemoList().then(res => {
          if(res.userList && res.userList.length){
            this.$toast('MOCK数据加载成功!');
            this.demoList = res.userList;
          }else {
            this.$toast('暂无数据!');
          }
        }).catch(err=>{
          console.log(err);
        })
      }
    }
  }
</script>

<style type="less" scoped>
  .item-list-wrap a {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/list.vue